export default "__VITE_ASSET__BkkP0mbb__"